/**
 * Menu script
 */
class PWSJO_Menu {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.site-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menuBlock = this.menuWrapper.find('.menu-wrapper');
        this.menuBlockItem = this.menuBlock.find('.menu-item.menu-item-has-children');
        this.menuSidebar = $('.sidebar .menu');
        this.menuSidebarItem = this.menuSidebar.find('.menu-item.menu-item-has-children');
        this.menuSidebarItemSubmenu = this.menuSidebarItem.find('.sub-menu');
        this.menuSidebarItemAncestor = this.menuSidebar.find('.menu-item.current-menu-ancestor');
        this.desktopViewport = window.matchMedia('(min-width: 1040px)');
    }

    initEvents() {
        this.menuSidebarItem.append( "<span class='arrow'></span>" );
        this.menuSidebarArrow = this.menuSidebarItem.find('.arrow');

        if (this.desktopViewport.matches) {
            this.menuBlockItem.attr('aria-expanded', 'false');

            for (let i = 0; i < this.menuBlockItem.length; i++) {
                this.menuBlockItem.eq(i).on('click', e => {
                    let menuItemValue = this.menuBlockItem.eq(i).attr('aria-expanded');

                    this.menuBlockItem.attr('aria-expanded', 'false');
                    this.menuBlockItem.eq(i).attr('aria-expanded', 'true');

                    if (  menuItemValue === 'true' ) {
                        this.menuBlockItem.eq(i).attr('aria-expanded', 'false');
                    }
                });
            }
        }

        if (this.menuIcon.length) {
            this.menuIcon.on('click', e => {
                e.preventDefault();
                let menuIconValue = this.menuIcon.attr('aria-expanded');
                this.menuBlock.toggleClass('is-active');
                this.menuIcon.toggleClass('is-active');
                this.menuIcon.attr('aria-expanded', 'true');
                
                $(document.body).toggleClass('no-scroll');

                if ( menuIconValue === 'true') {
                    this.menuIcon.attr('aria-expanded', 'false');
                }

                setTimeout(() => {
                    this.menuBlock.toggleClass('is-showing');
                }, 150);
            });
        }

        if (this.menuSidebarItemAncestor.length) {
            this.menuSidebarItemAncestor.addClass('active');
        }
        
        if (this.menuSidebar.length) {
            this.menuSidebarItemSubmenu.wrap( '<div class="sub-menu-wrapper"></div>' );

            this.menuSidebarArrow.each(function(i, item) {
                $(item).parent().find('.sub-menu-wrapper').css('height', 0);

                if ($(item).parent().hasClass('active')) {
                    $(item).parent().find('.sub-menu-wrapper').css('height', 'auto');
                }

                $(item).on("click", function () {
                    var item = $(this);
                    var contentWrapper = item.parent().find('.sub-menu-wrapper');
                    var contentText = item.parent().find('.sub-menu');

                    item.parent().toggleClass('active');
                    var newHeight = contentText.outerHeight();

                    if (item.parent().hasClass('active')) {
                        contentWrapper.css('height', 0);

                        setTimeout(function() {
                            contentWrapper.css('height', newHeight + 'px');
                        }, 0);

                        setTimeout(function() {
                            contentWrapper.css('height', 'auto');
                        }, 500);
                    } else {
                        contentWrapper.css('height', newHeight + 'px');

                        setTimeout(function() {
                            contentWrapper.css('height', 0);
                        }, 0);
                    }
                });
            });
        }
    }
}
